import { createSlice } from '@reduxjs/toolkit';
import { setToken } from '../Utilidades/session';

export const authUserSlice = createSlice({
  name: 'authUser',
  initialState: {
    name: '',
    loggedIn: false,
    validoSesion: false,
    token: '',
    imageUrl: '',
    googleId: '',
    email: '',
    pantallas: [],
    usuarioId: 0,
    redi: '',
  },
  reducers: {
    login: (state, action) => {
      state.name = action.payload.name;
      //state.token = action.payload.accessToken;
      state.imageUrl = action.payload.imageUrl;
      state.googleId = action.payload.googleId;
      state.email = action.payload.email;
      state.loggedIn = true;
      state.usuarioId = action.payload.usuarioId;
      state.pantallas = action.payload.pantallas;
      state.validoSesion = true;
    },
    token: (state, action) => {
      state.token = action.payload.access_token;
    },
    //Modificacion: Marca de Inicio WII C-24-1229-24
    redipa: (state, action) => {
      state.redi = action.payload.panta
    },
    //Modificacion: Marca de Fin WII C-24-1229-24
    logout: (state) => {
      setToken('');
      state.loggedIn = false;
      state.name = '';
      state.imageUrl = '';
      state.token = '';
      state.googleId = '';
      state.email = '';
      state.pantallas = [];
      state.usuarioId = 0;
      state.validoSesion = true;
    },
  },
});

// Action creators are generated for each case reducer function
export const { login, logout, token, redipa } = authUserSlice.actions;

export default authUserSlice.reducer;
